/**
 * Seed state for mock-mode (`VITE_USE_LIVE_API=false`) teacher admin: shared
 * by the chatbot and vector-store admin modules, which mutate it in place.
 */
import type { Chatbot, VectorStore, VectorStoreDocument } from '../types';

export const mockAdminChatbots: Chatbot[] = [
  {
    id: '8f3c2a1b-6d4e-4f90-b871-2e9c5d8a7f61',
    navn: 'GymGPT',
    beskrivelse: '',
    velkomstbesked: 'Hvad kan jeg hjælpe med?',
    systemprompt: '',
    vectorStoreId: null,
    status: 'published',
    slug: 'default',
    createdAt: '2026-06-18T12:00:00Z',
    updatedAt: '2026-06-18T12:00:00Z',
  },
];

export const mockAdminVectorStores: VectorStore[] = [
  {
    id: '00000000-0000-0000-0000-000000000001',
    navn: 'Matematik pensum',
    beskrivelse: 'Folkeskole algebra',
    tilladChunking: true,
    synligForLaerere: true,
    uploadedFile: null,
    createdAt: '2026-06-22T12:00:00Z',
    updatedAt: '2026-06-22T12:00:00Z',
  },
];

export const mockAdminDocuments = new Map<string, VectorStoreDocument[]>([
  [
    '00000000-0000-0000-0000-000000000001',
    [
      {
        id: '00000000-0000-0000-0000-000000000101',
        vectorStoreId: '00000000-0000-0000-0000-000000000001',
        filename: 'notes.md',
        status: 'ready',
        errorMessage: null,
        createdAt: '2026-06-22T12:00:00Z',
        updatedAt: '2026-06-22T12:00:00Z',
      },
    ],
  ],
]);
